import events from '../../../actions/event-names';
import Config from '../../../config';
import { showError, showSuccess } from '../../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    sideEffectList: [],
    isDetailsFetched: false,
    sideEffectDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_SIDE_EFFECT_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.sideEffectList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_SIDE_EFFECT_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            sideEffectList: [...state.sideEffectList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_SIDE_EFFECT_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_SIDE_EFFECT_DETAILS}_PENDING`: {
        return {
            ...state,
            sideEffectDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_SIDE_EFFECT_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_SIDE_EFFECT_DETAILS}_FULFILLED`: {
        return {
            ...state,
            sideEffectDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_SIDE_EFFECT_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_SIDE_EFFECT_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_SIDE_EFFECT_DETAILS}_PENDING`: {
        return {
            ...state,
            savesideEffectDetails: 'PENDING',
        };
    }
    case `${events.SAVE_SIDE_EFFECT_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_SIDE_EFFECT_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            savesideEffectDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_SIDE_EFFECT_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_SIDE_EFFECT_DETAILS}_REJECTED`: {
        return {
            ...state,
            savesideEffectDetails: 'REJECTED',
        };
    }

  

    case `${events.ADD_NEW_SIDE_EFFECT}_PENDING`: {
        return {
            ...state,
            isNewsideEffectAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_SIDE_EFFECT}_FULFILLED`: {
        showSuccess("New side effect added successfully")
        return {
            ...state,
            isNewsideEffectAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_SIDE_EFFECT}_REJECTED`: {
        return {
            ...state,
            isNewsideEffectAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_SIDE_EFFECT}_PENDING`: {
        return {
            ...state,
            issideEffectDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_SIDE_EFFECT}_FULFILLED`: {
        showSuccess("Side Effect deleted successfully")
        return {
            ...state,
            issideEffectDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_SIDE_EFFECT}_REJECTED`: {
        return {
            ...state,
            issideEffectDeleted: 'REJECTED',
        };
    }
    

    






    default:
        return state;
    }
}
